export const isObject = (obj: any): boolean => obj !== null && typeof obj === 'object';
